// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".toast-box[data-v-63e30282] {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  z-index: 9999;\n  transform: translate(-50%, -50%);\n  height: 70px;\n  background: rgba(0, 0, 0, 0.7);\n  color: #fff;\n  padding: 20px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n}\n.toast-box > .icon[data-v-63e30282] {\n  font-size: 35px;\n  padding-right: 10px;\n}\n.toast-box > span[data-v-63e30282] {\n  font-size: 24px;\n}\n", ""]);
// Exports
module.exports = exports;
